import { AttachSystemFilesModalProps } from './AttachSystemFilesModal';
import { openModal } from '@core/components/ModalStack';

export async function openAttachSystemFilesModal(props: AttachSystemFilesModalProps) {
  const { AttachSystemFilesModal } = await import('./AttachSystemFilesModal');

  openModal(AttachSystemFilesModal, props);
}
